module.exports = __webpack_public_path__ + "static/media/gps.847d96dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gps.png
// module id = 1155
// module chunks = 2